import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Screen1Hero } from './components/teaser/Screen1Hero';
import { Screen3Ranking } from './components/teaser/Screen3Ranking';
import { Screen5Memory } from './components/teaser/Screen5Memory';
import { Screen6Video } from './components/teaser/Screen6Video';
import { Screen7Input } from './components/teaser/Screen7Input';
export function App() {
  const [screen, setScreen] = useState(0);
  const next = () => setScreen(s => Math.min(s + 1, 4));
  const restart = () => setScreen(0);
  const screens = [<Screen1Hero key="1" onNext={next} data-id="element-0" />, <Screen3Ranking key="3" onNext={next} data-id="element-1" />, <Screen5Memory key="5" onNext={next} data-id="element-2" />, <Screen6Video key="6" onNext={next} data-id="element-3" />, <Screen7Input key="7" onRestart={restart} data-id="element-4" />];
  return <div className="min-h-screen w-full bg-black flex items-center justify-center" data-id="element-5">
      <div className="relative overflow-hidden bg-slate-950 w-full h-screen sm:h-[760px] sm:w-[380px] sm:rounded-[2.4rem] sm:shadow-[0_30px_80px_rgba(0,0,0,0.6),0_0_60px_rgba(220,38,38,0.15)]" data-id="element-6">
        {/* Status bar */}
        <div className="absolute top-0 inset-x-0 z-20 h-8 px-6 flex items-center justify-between text-[10px] text-white/90 font-medium pointer-events-none" data-id="element-7">
          <span data-id="element-8">9:41</span>
          <div className="flex items-center space-x-1" data-id="element-9">
            <span data-id="element-10">●●●</span>
            <span data-id="element-11">5G</span>
            <span data-id="element-12">100%</span>
          </div>
        </div>

        {/* Progress dots */}
        <div className="absolute top-10 left-0 right-0 z-20 flex justify-center space-x-1 px-8 pointer-events-none" data-id="element-13">
          {screens.map((_, i) => <div key={i} className={`h-0.5 flex-1 rounded-full transition-all duration-500 ${i <= screen ? 'bg-red-500' : 'bg-white/15'}`} data-id="element-14" />)}
        </div>

        {/* Screens */}
        <AnimatePresence mode="wait" data-id="element-15">
          <motion.div key={screen} initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="absolute inset-0" data-id="element-16">
            {screens[screen]}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
}